import { useState } from 'react'
import { useTexte } from '../../texte'

import { fehlertext } from '../../api/client'
import { useMe, useSetDarstellung, useSettings } from '../../hooks/queries'
import { ausEinstellungen, ausKonto, fuerServer, type Listensatz } from '../../lib/listenfarben'
import { Listenwahl } from './Listenwahl'

/**
 * Die Farben der Reiseübersicht — **an diesem Konto** (#54).
 *
 * **Diese Karte steht bei jedem**, nicht nur bei der Verwaltung: sie regelt
 * nichts an einer Reise, sondern etwas an den Augen dessen, der davorsitzt —
 * dieselbe Begründung wie bei der Schriftgröße daneben.
 *
 * **Leer heißt „wie die Voreinstellung"**, und der Knopf an jeder Zeile sagt
 * genau das. Aus dem Issue: „Diese können mit einem Knopf auf die
 * Voreinstellung zurück."
 */
export function Listenfarben() {
  const t = useTexte()
  const me = useMe()
  const vorein = useSettings()
  const sichern = useSetDarstellung()
  const [gemeldet, setGemeldet] = useState(false)
  const [problem, setProblem] = useState<string | null>(null)

  return (
    <div className="card card--seite">
      <h2 className="card__titel">{t.bausteine.farbnamen.liste}</h2>
      <Listenwahl
        lead={t.farben.listeEigeneLead}
        werte={ausKonto(me.data)}
        /* Solange hier nichts steht, gilt die Voreinstellung -- und genau die
           zeigt dann auch das Farbfeld. */
        ererbt={ausEinstellungen(vorein.data?.settings)}
        leerText={t.farben.voreinstellung}
        alleText={t.farben.allesVoreinstellung}
        laeuft={sichern.isPending}
        fehler={problem}
        gemeldet={gemeldet}
        onSpeichern={async (satz: Listensatz) => {
          setGemeldet(false)
          setProblem(null)
          try {
            await sichern.mutateAsync(fuerServer(satz))
            setGemeldet(true)
          } catch (fehler) {
            setProblem(
              fehlertext(fehler),
            )
            throw fehler
          }
        }}
      />
    </div>
  )
}
